require("slick-carousel");

export default () => {
    const elements = getCarousels();

    if (elements.length > 0) {
        for (const element of elements) {
            $(element).slick({
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2000,
                swipeToSlide: true,
                speed: 300,
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
            });
        }
    }
};

function getCarousels() {
    return document.querySelectorAll('.slick-slider');
}
